import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { Dependencies } from '@adornis/materialized-views/decorators/dependency.js';
import countries from 'i18n-iso-countries';
import type { Gender, Konfession, NamensTitel, Religion } from '../../../db/enums/misc-enums.js';
import type { Namensvorsatz } from '../../../db/enums/namensvorsatz.js';
import type { Namenszusatz } from '../../../db/enums/namenszusatz.js';

@Entity()
export class StammDaten extends AdornisEntity {
  static override _class = 'Stammdaten';

  constructor(doc: PartialEntityData<StammDaten>) {
    super(doc);
  }

  @Field(() => String)
  titel: Maybe<NamensTitel>;

  @Field(() => String)
  vorname: Maybe<string>;

  @Field(() => String)
  nachname: Maybe<string>;

  @Field(() => String)
  namenszusatz: Maybe<Namenszusatz>;

  @Field(() => String)
  vorsatzWort: Maybe<Namensvorsatz>;

  @Field(() => String)
  telefonNr: Maybe<string>;

  @Field(() => Date)
  geburtsDatum: Maybe<Date>;

  @Field(() => String)
  geschlecht: Maybe<Gender>;

  @Field(() => String)
  geburtsLand: Maybe<string>;

  @Dependencies({
    classes: () => [],
    ids: () => [],
  })
  @Field(() => String, {
    resolve: function (this: StammDaten) {
      return () => (this.geburtsLand ? countries.getName(this.geburtsLand, 'de') : null);
    },
  })
  geburtsLandFullName: Maybe<string>;

  @Field(() => String)
  geburtsOrt: Maybe<string>;

  @Field(() => String)
  staatsangehoerigkeit: Maybe<string>;

  @Dependencies({
    classes: () => [],
    ids: () => [],
  })
  @Field(() => String, {
    resolve: function (this: StammDaten) {
      return () => (this.staatsangehoerigkeit ? countries.getName(this.staatsangehoerigkeit, 'de') : null);
    },
  })
  staatsangehoerigkeitFullName: Maybe<string>;

  @Field(() => String)
  staatsangehoerigkeit2: Maybe<string>;

  @Dependencies({
    classes: () => [],
    ids: () => [],
  })
  @Field(() => String, {
    resolve: function (this: StammDaten) {
      return () => (this.staatsangehoerigkeit2 ? countries.getName(this.staatsangehoerigkeit2, 'de') : null);
    },
  })
  staatsangehoerigkeit2FullName: Maybe<string>;

  @Field(() => String)
  konfession: Maybe<Konfession>;

  @Field(() => String)
  religion: Maybe<Religion>;

  @Field(() => String)
  beruf: Maybe<string>;
}
